import moment from 'moment';

export function changeDateLocale(locale) { moment.locale(locale); }

export function momentInCurrentTimeZone(date, format) {
    const fArgs = [date];
    if (format) fArgs.push(format);
    return moment.utc(...fArgs).local();
}

export function currentTimeZoneInMilisec(date) {
    return momentInCurrentTimeZone(date).toDate().valueOf();
}

export function isDayToday(date) {
    return momentInCurrentTimeZone().isSame(momentInCurrentTimeZone(date), 'day');
}
